<template lang="pug">
v-container
  .container(v-if="myAct")
    div.card-container.mb-2
      h3 {{ message }}
      h3.mr-2 Направленный
      v-icon mdi-file-download-outline 
    v-card.pointer.mb-8( class="mx-auto" max-width="400" @click="getExport()")
      v-card-title {{ myAct.name	 }}
    div.card-container.mb-2
      h3.mr-2 Подписанный
      v-icon mdi-file-upload-outline 
    input( type="file" accept=".pdf, .jpg, .jpeg, .png" style="display: none" ref="fileInput" multiple @change="uploadFile" )
    v-btn.app-btn-action.mb-8( v-if="myAct.editable" @click="$refs.fileInput.click()") Загрузить подписанный файл
    v-card.pointer( class="mx-auto" max-width="400" @click="downloadSignedAct")
      v-card-title(v-if="signedActs" v-for="act in signedActs" :key="act.id") {{ act.name }}
  v-dialog( v-model="loading" persistent )
    v-card.loading-container
      v-card-title {{ dialogTitle }}
      v-progress-circular.mb-3( :size="50" color="primary" indeterminate )
  .container.no-info(v-if="!myAct")
    span.mx-auto Нет назначенного акта на данный месяц
  div.overlay(v-if="previewDocument")
    div.viewer-content
      div.top-controls
        button(@click="closeShowDocument") Отменить
        button(@click="saveLoadedFile" :disabled="files.length === 0") Сохранить
      img(:src="currentFile.url" :alt="currentFile.name")
      button.nav-left(@click="prev" :disabled="currentIndex === 0") ‹
      button.nav-right(@click="next" :disabled="currentIndex === files.length - 1") ›
      div.counter {{ currentIndex + 1 }} / {{ files.length }}
</template>
<script>
import { mapState, mapActions } from "vuex";
import { actService } from "../../../_services/act.service";
import { fileService } from "../../../_services/file.service"

export default {
  props: [ 'year', 'mid'],

  data: () => ({
    loading: false,
    file: null,
    download: false,
    previewDocument: false,
    files: [],
    currentIndex: 0,
    loadedFiles: [],
    message: null,
  }),

  computed: {
    ...mapState("act", ['myAct', 'signedActs']),

    dialogTitle() {
      return this.download ? "Скачивание файла" : "Загрузка файла"
    },

    currentFile() {
      return this.files[this.currentIndex];
    }
  },

  methods: {
    ...mapActions("act", ['loadMyAct', 'downloadAct', 'saveLoadActs']),

    saveLoadedFile(){
      let signedAct = {
        actId: this.myAct.id,
        tempFileList: this.loadedFiles
      };
      this.saveLoadActs(signedAct).then(() => {
        this.loadedFiles = []
        this.files = []
        this.previewDocument = false
      })

    },

    openViewer(fileList, startIndex = 0) {
      this.files = []
      fileList.map(el => {
        el.url = URL.createObjectURL(el)
        this.files.push(el)
      })
      
      this.currentIndex = startIndex;
      this.previewDocument = true;
    },

    checkPdf(file) {
      return file.type == 'application/pdf';
    },

    next() {
      if (this.currentIndex < this.files.length - 1) {
        this.currentIndex++;
      }
    },

    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },

    closeShowDocument(){
      this.loadedFiles.map(file => {
        actService.deleteTmpFile(file.photo)
      })
      this.loadedFiles = []
      this.files = []
      this.previewDocument = false
    },

    getExport() {
      this.loading = true;
      this.download = true
      let act = this.myAct
      let nameMonth = new Date(2025, this.myAct.month -1).toLocaleString('default', { month: 'long' })
      actService.downloadAct(this.myAct.id).then((response) => {
        let content_disposition = response.headers['content-disposition'];
        let idx = content_disposition.indexOf('filename*=UTF-8\'\'');
        let filename = idx != -1 ?   "Акт_" + nameMonth.charAt(0).toUpperCase() + nameMonth.slice(1) + "_" + act.merch.name : 'export';
        let tempEl = document.createElement("a");
        document.body.appendChild(tempEl);
        tempEl.style = "display: none";
        if ((typeof response.data) == 'string') {
          tempEl.href = response.data;
        } else {
          let blob = response.data;
          let objectURL = URL.createObjectURL(blob);
          tempEl.href = objectURL;
        }
        tempEl.download = filename;
        tempEl.click();
        tempEl.remove();
      }).catch(error => alert('Ошибка при экспорте ' + (error.description ? error.description : '')))
      .finally(() => {
        this.loading = false
        this.download = false
      })
    },

    downloadSignedAct(){
      this.loading = true
      this.download = true
      let date = new Date(this.myAct.signedDate)
      let act = this.myAct
      date = date.toISOString().split('T')[0]
      actService.downloadSignedAct(act.id).then((response) => {
      let filename = act.merch.name + "_" + date
      let blob = response.data;
      let objectURL = URL.createObjectURL(blob);
      let tempEl = document.createElement("a");
      document.body.appendChild(tempEl);
      tempEl.style = "display: none";
      tempEl.href = objectURL;
      tempEl.download = filename;
      tempEl.click();
      tempEl.remove();
      }).catch(error => alert('Ошибка при экспорте ' + (error.description ? error.description : '')))
      .finally(() => {
        this.loading = false
      })
    },

    async uploadFile(event) {
      let files = event.target.files;
      if (files && files.length) {
        this.loading = true;
        this.download = false;
        let fileArray = Array.from(files);
        try {
          let uploadedFiles = await Promise.all(
            fileArray.map(async (el) => {
              try {
                const arrayBuffer = await el.arrayBuffer();
                const blob = new Blob([arrayBuffer], { type: el.type });
                const file = new File([blob], el.name, { type: el.type });
                let formData = new FormData();
                formData.append("file", file);
                return fileService.uploadFile(formData);
              } catch (readError) {
                throw new Error(`Не удалось прочитать файл "${el.name}": ${readError.message}`);
              }
            })
          )
          this.loadedFiles = uploadedFiles
          let forViewer = await Promise.all(
            uploadedFiles.map(el => actService.showTempfiles(el))
          );

          let arrayImages = [];
          for (let el of forViewer) {
            const blobs = await this.pdfToJpegBlobs(el.data);
            arrayImages.push(...blobs);
          }
          this.openViewer(arrayImages)
          
        } catch (error) {
          window.alert(error)
          console.error("Ошибка при загрузке файлов:", error);
        } finally {
          this.loading = false;
          event.target.value = ''
        }
      }
    },

    async pdfToJpegBlobs(pdfBlob) {
      let arrayBlobs = []
      if(this.checkPdf(pdfBlob)){
        const arrayBuffer = await pdfBlob.arrayBuffer();
        const pdf = await window.pdfjsLib.getDocument({ data: arrayBuffer }).promise;
        for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
          const page = await pdf.getPage(pageNum);
          const scale = 2;
          const viewport = page.getViewport({ scale });

          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          canvas.width = viewport.width;
          canvas.height = viewport.height;

          await page.render({ canvasContext: context, viewport }).promise;
          const blob = await new Promise(resolve => 
            canvas.toBlob(resolve, 'image/jpeg', 0.9)
          );

          arrayBlobs.push(blob)
        }
      } else {
        arrayBlobs.push(pdfBlob)
      }
      

      return arrayBlobs;
    }
  }
}
</script>
<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;
}
.card-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 400px;
  width: 100%;
  justify-content: flex-start;
}
.app-btn-action {
  height: 32px;
  margin: 0px;
  padding-top: 7px;
  padding-bottom: 7px;
  background-color: white;
  color: black;
  text-align: center;
  border: 1px dashed grey;
  box-sizing: border-box;
  border-radius: 4px;
  cursor: pointer;
  max-width: 400px;
  width: 100%;
}
.loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.no-info {
  display: flex;
  align-items: center;
  justify-content: center;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.viewer-content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.overlay img,
.overlay iframe {
  max-width: 80%;
  max-height: 80%;
  box-shadow: 0 0 15px black;
  border-radius: 6px;
}
.top-controls {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 12px;
  z-index: 2000;
}
.top-controls button {
  background: rgba(255,255,255,0.9);
  border: none;
  padding: 8px 16px;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
}
.nav-left, .nav-right {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255,255,255,0.8);
  border: none;
  font-size: 28px;
  cursor: pointer;
  padding: 12px 18px;
  border-radius: 50%;
  z-index: 2000;
  user-select: none;
}
.nav-left { left: 30px; }
.nav-right { right: 30px; }
.counter {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
  font-size: 16px;
  background: rgba(0,0,0,0.6);
  padding: 6px 12px;
  border-radius: 4px;
}
</style>